<template>
  <div class="empty-state">
    <!-- .empty-state-container -->
    <div class="empty-state-container">
      <div class="state-figure">
        <img class="img-fluid" src="assets/images/illustration/img-2.svg" alt="" style="max-width: 320px" />
      </div>
      <h3 class="state-header"> Page Not found! </h3>
      <p class="state-description lead text-muted"> Sorry, we've misplaced that URL or it's pointing to something that doesn't exist. </p>
      <div class="state-action">
        <a v-bind:href="url" class="btn btn-lg btn-light"><em class="fa fa-angle-right"></em> Go Back</a>
      </div>
    </div><!-- /.empty-state-container -->
  </div><!-- /.empty-state -->
</template>

<script>

import store from '@/store'

export default {
  name: "NotFound",
  data(){
    return {
      url:""
    }
  },
  beforeRouteEnter(to, from, next) {

    next(vm=>{
      if(store.state.menus.length > 0){
        vm.url = from.fullPath
      }else {
        store.commit('TOGGLE_LOADING', false)
        vm.url = '/logout'
      }

    })
  },
}
</script>